import React from "react";
import { useLanguage } from "../../context/LanguageContext";

// Phase-6: Display rename — "submitted" + "resubmitted" both render as "In Pool".
// "resubmitted" gets a small secondary tag so reviewers can still distinguish.
const STATUS_STYLES = {
  draft:                 "bg-slate-100 text-slate-700 border-slate-200",
  submitted:             "bg-slate-100 text-slate-700 border-slate-200",
  resubmitted:           "bg-slate-100 text-slate-700 border-slate-200",
  under_review:          "bg-blue-50 text-blue-700 border-blue-100",
  needs_correction:      "bg-amber-50 text-amber-700 border-amber-100",
  approved:              "bg-emerald-50 text-emerald-700 border-emerald-100",
  paid:                  "bg-teal-50 text-teal-700 border-teal-100",
  pending_re_edit:       "bg-orange-50 text-orange-700 border-orange-200",
  // Legacy (pre-Phase 12 cases that escaped the startup migration) — kept so
  // any straggler renders rather than fallback to `draft`.
  paid_to_reviewer:      "bg-teal-50 text-teal-700 border-teal-100",
  repayment_submitted:   "bg-teal-50 text-teal-700 border-teal-100",
  rejected:              "bg-rose-50 text-rose-700 border-rose-100",
  closed:                "bg-slate-100 text-slate-500 border-slate-200",
};

const labelKey = (status) => {
  if (status === "submitted" || status === "resubmitted") return "case_status_in_pool";
  return `case_status_${status}`;
};

export const CaseStatusPill = ({ status }) => {
  const { t } = useLanguage();
  const cls = STATUS_STYLES[status] || STATUS_STYLES.draft;
  return (
    <span className="inline-flex items-center gap-1.5" data-testid={`case-status-${status}`}>
      <span
        className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${cls}`}
      >
        {t(labelKey(status))}
      </span>
      {status === "resubmitted" ? (
        <span
          className="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium uppercase tracking-wider bg-violet-50 text-violet-700 border border-violet-100"
          data-testid="case-status-resubmitted-tag"
        >
          {t("case_status_resubmitted_short")}
        </span>
      ) : null}
    </span>
  );
};

export default CaseStatusPill;
